export const ApiUrl = "https://cms.chengaidiocese.org/api";

// for production
export const ReligioUrl = "https://dcerp.in/api";

// for development
// export const ReligioUrl = "http://172.104.106.91:8267/api";